import { render, staticRenderFns } from "./OverviewFuelCoco.vue?vue&type=template&id=3b18fe5e"
import script from "./OverviewFuelCoco.vue?vue&type=script&lang=js"
export * from "./OverviewFuelCoco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports